import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const ProspectActivityEmailSent = () => (
  <ImageIcon src={Images.ProspectActivityEmailSent} alt="empty-data/" />
);

export default ProspectActivityEmailSent;
